import { useEffect, useRef } from "react";

export function useValidEmailsRef(validEmails: string[]) {
  const validEmailsRef = useRef<string[]>([]);

  useEffect(() => {
    validEmailsRef.current = validEmails;
  }, [validEmails]);

  return validEmailsRef;
}
